export const additionalCostDefinitions = [
  {
    key: "catering",
    translationKey: "additionalCosts.catering",
    aliases: ["Catering", "Verpflegung / Catering", "Verpflegung / Catering pro Teilnehmer", "Catering per participant"],
  },
  {
    key: "travelCosts",
    translationKey: "additionalCosts.travelCosts",
    aliases: [
      "Reisekosten",
      "Übernachtungskosten",
      "Reisekostenpauschale für Trainer (Anreise und Unterbringung)",
      "Reisekostenpauschale für Dozent (Anreise und Unterbringung)",
      "Trainer travel expenses (travel and accommodation)",
      "Trainer travel and accommodation",
    ],
  },
  { key: "notebookRental", translationKey: "additionalCosts.notebookRental", aliases: ["Notebookleihe", "Laptop hire"] },
  {
    key: "cloudService",
    translationKey: "additionalCosts.cloudService",
    aliases: [
      "Cloud Service",
      "Cloud service",
      "Komplette Lernumgebung in der Cloud mit Remotezugriff",
      "Komplette Lernumgebung in der Cloud mit Remote Zugriff",
      "Complete cloud learning environment with remote access",
    ],
  },
  {
    key: "documents",
    translationKey: "additionalCosts.documents",
    aliases: ["Seminarunterlagen", "Schulungsunterlagen", "Schulungsunterlagen pro Teilnehmer", "Training materials per participant"],
  },
  {
    key: "specialistBooks",
    translationKey: "additionalCosts.specialistBooks",
    aliases: [
      "Fachbücher",
      "Themenspezifische Fachbücher für Ihre Bibliothek",
      "Topic-specific specialist books for your library",
      "Subject-specific books for your library",
    ],
  },
  { key: "roomRental", translationKey: "additionalCosts.roomRental", aliases: ["Raummiete", "Room hire"] },
];

export const dynamicAdditionalCostDefinitions = [
  {
    key: "seminarRoom",
    translationKey: "additionalCosts.seminarRoom",
    patterns: [/^Seminarraum für bis zu (\d+) Teilnehmer$/i, /^Training room for up to (\d+) participants$/i],
    params: (match) => ({ capacity: match[1] }),
  },
  { key: "surcharge", patterns: [/^zzgl\..*$/i, /^plus\b.*$/i] },
];

export const exactCombitDefaults = {
  seminarDate: [
    { aliases: ["Nach Absprache", "By arrangement"], translationKey: "combitDefaults.dateByArrangement" },
  ],
  location: [
    { aliases: ["Online"], translationKey: "combitDefaults.locations.online" },
    {
      aliases: ["Im Gfu-Schulungszentrum", "Im GFU-Schulungszentrum", "Im GFU Schulungszentrum", "At the GFU Training Centre"],
      translationKey: "combitDefaults.locations.gfu",
    },
    {
      aliases: ["Im GFU-Seminarzentrum in Köln", "At the GFU Training Centre in Cologne"],
      translationKey: "combitDefaults.locations.gfuCologne",
    },
    {
      aliases: ["Online oder im GFU-Schulungszentrum", "Online oder im GFU Schulungszentrum", "Online or at the GFU Training Centre"],
      translationKey: "combitDefaults.locations.onlineOrGfu",
    },
  ],
};

export const dynamicLocationDefinitions = [
  {
    pattern: /^Bei Ihnen in (.+)$/i,
    translationKey: "combitDefaults.locations.customer",
    params: (match) => ({ city: match[1] }),
  },
  {
    pattern: /^Im GFU-Seminarzentrum oder in Ihrem Hause in (.+)$/i,
    translationKey: "combitDefaults.locations.gfuOrCustomer",
    params: (match) => ({ city: match[1] }),
  },
  {
    pattern: /^Im Gfu-Schulungszentrum oder bei Ihnen in (.+)$/i,
    translationKey: "combitDefaults.locations.gfuOrCustomer",
    params: (match) => ({ city: match[1] }),
  },
];
